import { PageHeader } from "@/components/common/ui-kit";
import { OrdersList } from "@/components/orders/OrdersList";

export default function OrdersPage() {
  return (
    <div data-testid="orders-page">
      <PageHeader overline="Sales" title="Ordini cliente" description="Ciò che il cliente ha effettivamente ordinato, creato esplicitamente da una revisione di offerta accettata, con prezzi congelati e avanzamento gestionale." />
      <OrdersList />
    </div>
  );
}
